import axios from "axios";
import { useCallback, useState } from "react";
import { URL } from "../../config";
import { useSelector } from "react-redux";

const UpdateUserProfile = () => {
    const [isLoadingProfile, setIsLoading] = useState(false);
    const [errorProfile, setError] = useState(null);
    const [successProfile, setSuccess] = useState(false);
    const [dataProfile, setData] = useState(null);
    const {token}=useSelector((state)=>state.AuthReducer);
    const makeRequestProfile = useCallback(async (requestData) => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await axios.post(`${URL}/api/profile/update`, requestData,{
            headers:{
                Authorization:`Bearer ${token}`,
                'Accept':'application/json',
                'Content-Type':'application/json'
            }});
        setData(response.data);
        setSuccess(true)
      } catch (err) {
        setError(err);
      }
      setIsLoading(false);
    }, [token]);
  
    return { makeRequestProfile, dataProfile, isLoadingProfile, errorProfile,successProfile };
}

export default UpdateUserProfile